// extracted by mini-css-extract-plugin
export var FeedbackItem = "Feedbacker-module--FeedbackItem--5a943";
export var slideIn = "Feedbacker-module--slideIn--d7155";
export var slideOut = "Feedbacker-module--slideOut--9dd19";